export function formatTimestamp(
  timestamp: string,
  showDetailedTime = true,
  showTime = true,
): string {
  const utcDate = new Date(timestamp);
  const osloTime = new Date(utcDate.getTime());

  const year = osloTime.getFullYear();
  const month = String(osloTime.getMonth() + 1).padStart(2, '0');
  const day = String(osloTime.getDate()).padStart(2, '0');

  if (!showTime) {
    return `${day}-${month}-${year}`;
  }

  const hour = String(osloTime.getHours()).padStart(2, '0');
  const minute = String(osloTime.getMinutes()).padStart(2, '0');

  let formattedOsloTime = `${day}-${month}-${year} ${hour}:${minute}`;

  if (showDetailedTime) {
    const second = String(osloTime.getSeconds()).padStart(2, '0');
    const milliseconds = String(osloTime.getMilliseconds()).padStart(3, '0');
    formattedOsloTime += `:${second}.${milliseconds}`;
  }

  return formattedOsloTime;
}
